import { createRouter, createWebHistory } from 'vue-router';

import DataCalculator from '@/components/DateCalculator.vue';

const routes = [
  {
    path: '/',
    name: 'DataCalculator',
    component: DataCalculator,
  },
  {
    path: '/calculate-matrix',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
